
<button mat-raised-button class="addCardBtn" (click)="addCard()" [disabled]="disabled">
  Add another card
</button>

<div class="aside-overlay" [class.open]="asideOpen" (click)="onCancel()"></div>
<div class="aside-panel" [class.open]="asideOpen">

  <h3>Add a different card</h3>

  <div id="form-container">
    <div id="sq-card"></div>
  </div>

  <footer class="footer" style="display: block;">
    <button mat-raised-button class="cancelBtn" (click)="asideOpen = false">
      Close
    </button>
    <button id="sq-creditcard" mat-raised-button color="accent" align="end" class="submitBtn" (click)="onGetCardNonce($event)" [disabled]="upgrading">
      @if (upgrading) {
        <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
      }
      @if (!upgrading) {
        <span>Add Card</span>
      }
    </button>
  </footer>
</div>